module.exports = __webpack_public_path__ + "static/media/clearpay-logo.65c7d1d1.png";